<template>
    <div class="Login-container">
        <div id="main" style="width: 380px;height:220px;"></div>
    </div>
</template>

<script>
    const echarts = require('echarts');
    export default {
        data() {
            return {
                list: []
            }
        },
        watch: {
            list(n) {
                this.init()
            }
        },
        mounted() {
            this.getData()
        },
        methods: {
            getData() {
                this.list = [{
                        "x": "E1",
                        "y": "120"
                    },
                    {
                        "x": "E2",
                        "y": "170"
                    },
                    {
                        "x": "E3",
                        "y": "120"
                    },
                    {
                        "x": "E4",
                        "y": "190"
                    },
                    {
                        "x": "E5",
                        "y": "420"
                    },
                    {
                        "x": "E6",
                        "y": "180"
                    },
                    {
                        "x": "E7",
                        "y": "90"
                    },
                    {
                        "x": "E8",
                        "y": "40"
                    }
                ]
            },
            init() {
                // 基于准备好的dom，初始化echarts实例
                var myChart = echarts.init(document.getElementById('main'));

                let xAxisData = []
                let seriesData = []

                this.list.forEach((i, k) => {
                    xAxisData.push(i.x || '')
                    seriesData.push(i.y || 0)
                })



                // 指定图表的配置项和数据
                let option = {
                    title: {
                        subtext: '单位：次',
                        subtextStyle: {
                            //文字颜色
                            color: '#74a0bf',
                            //字体大小
                            fontSize: 12
                        }
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: xAxisData,
                        axisLine: {
                            lineStyle: {
                                type: 'solid',
                                color: '#74a0bf', //左边线的颜色
                                width: '1' //坐标线的宽度
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                // 坐标值得具体的颜色
                                color: '#74a0bf',
                                fontSize: 12
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        scale: true, //自适应
                        minInterval: 200, //分割刻度
                        max: function(value) { //取最大值向上取整为最大刻度
                            return Math.ceil(value.max + 200)
                        },
                        axisLine: {
                            lineStyle: {
                                type: 'solid',
                                color: '#74a0bf',
                                width: '1'
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#74a0bf',
                                fontSize: 12
                            }
                        },
                        splitLine: {
                            show: true, //X网格线
                            lineStyle: { //x网格线
                                color: '#002d37'
                            }
                        }
                    },
                    series: [{
                        data: seriesData,
                        type: 'bar',
                        barWidth: 8, //柱子的宽度
                        showBackground: true,
                        backgroundStyle: {
                            color: 'rgba(27, 31, 41,1)',

                        },
                        itemStyle: {
                            normal: {
                                // 圆角
                                barBorderRadius: [4, 4, 0, 0],
                                // 背景渐变
                                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 0,
                                    color: "#eb9c57" // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: "#ef4960" // 100% 处的颜色
                                }], false)
                            },

                        }
                    }],
                };

                // 使用刚指定的配置项和数据显示图表。
                myChart.setOption(option);
            }
        }
    }
</script>

<style lang="less">
    #main {
        margin: 200px 50px;
        background-color: #051c2c;
        color: #74a0bf;
    }
</style>
